export function getIsStopSale(state) {
  return state.core.isStopSale;
}

export function getAlertBlocks(state) {
  return state.core.alertBlocks;
}
